// UID: NPO-HOA-OCC_LDGR-FILE
// @see https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import IsHOA from '../rules/IsHOA';
import { RulesetResult } from '../rules/';

class CurrentOccupantLedgerRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isHoa = IsHOA.evaluate(data);
    return isHoa ? RulesetResult.REQUIRED : RulesetResult.HIDDEN;
  };
}

export default new CurrentOccupantLedgerRuleset();
